import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import React from 'react'

import MenuItemContainer from './MenuItemContainer'

const MenuItemView = ({ label, icon, href, title, onClick, target, rel }) => (
  <MenuItemContainer
    href={href}
    title={title}
    onClick={onClick}
    target={target}
    rel={rel}
  >
    {icon &&
      <FontAwesomeIcon icon={icon} className='icon fa-fw mr-2' />}
    {label}
  </MenuItemContainer>
)

MenuItemView.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.string,
  href: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func,
  target: PropTypes.string,
  rel: PropTypes.string
}

export default MenuItemView
